import React from "react";
import LoginHead from "../../component/AuthHead/LoginHead";
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const Login = () => {
  return (
    <div>
      <LoginHead />
      <section id="service-details" className="service-details">
        <div className="container" data-aos="fade-up" data-aos-delay="100">
          <div className="row gy-4 mobcol">
            <div className="col-lg-12">
              <Container style={{ width: "50%" }}>
                <Form>
                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Label>Email</Form.Label>
                    <Form.Control type="email" />
                  </Form.Group>
                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Label>Password</Form.Label>
                    <Form.Control type="password" />
                  </Form.Group>
                  <Button className="battoun">Login</Button>
                  <Link to={"/forgot-password"}>
                    <p
                      style={{
                        textAlign: "right",
                        fontSize: "12px",
                        paddingTop: "5px",
                        paddingRight: "5px",
                      }}
                    >
                      Forgot Password?
                    </p>
                  </Link>

                  <p
                    style={{
                      textAlign: "center",
                      fontSize: "12px",
                      paddingTop: "5px",
                      paddingRight: "5px",
                    }}
                  >
                    Don't have an account yet?
                    <Link to={"/register"}> SignUp </Link>
                  </p>
                </Form>
              </Container>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Login;
